import {
    Component,
    AfterViewInit
} from '@angular/core';
import { Canvas, Rect, Textbox } from 'fabric';
import { PencilBrush } from 'fabric';
import html2canvas from 'html2canvas';
import { PDFDocument } from 'pdf-lib';
import jsPDF from 'jspdf';

@Component({
    selector: 'app-pdf-drawing',
    templateUrl: './pdf-drawing.component.html',
    styleUrls: ['./pdf-drawing.component.scss']
})
export class PdfDrawingComponent implements AfterViewInit {

    private canvas!: Canvas;
    public pdfSrc = 'assets/sample2.pdf';
    public signatureInstance: any;

    async ngAfterViewInit(): Promise<void> {
    }

    async onPdfRendered(e: any) {
        const pdfCanvasContainer = document.querySelector('.ng2-pdf-viewer-container') as HTMLCanvasElement;
        const canvasElement = document.createElement('canvas');
        canvasElement.width = e.source.width;
        canvasElement.height = pdfCanvasContainer.scrollHeight;
        canvasElement.style.position = 'absolute';
        canvasElement.style.top = '0';
        canvasElement.style.left = '0';

        //canvasElement.style.pointerEvents = 'none';
        //canvasElement.style.zIndex = '-1';

        const wrapper = document.createElement('div');
        wrapper.id = 'canvasWrapper';
        wrapper.style.position = 'absolute';
        wrapper.style.top = '0';
        wrapper.style.left = '0';
        wrapper.style.width = '100%';
        wrapper.style.height = `${pdfCanvasContainer.scrollHeight}px`;

        pdfCanvasContainer.appendChild(wrapper);
        wrapper.appendChild(canvasElement);


        this.canvas = new Canvas(canvasElement, {
            allowTouchScrolling: true,
            backgroundColor: 'transparent',
            //isDrawingMode: true
        });
        const brush = new PencilBrush(this.canvas);
        brush.width = 3;
        brush.color = 'black';
        this.canvas.freeDrawingBrush = brush;

        /* setTimeout(() => {
            //const annotations = document.querySelectorAll('.annotationLayer, .buttonWidgetAnnotation .textWidgetAnnotation');
            const annotations = document.getElementsByClassName('textWidgetAnnotation')
            const inputs = document.querySelectorAll('.annotationLayer input');
            console.log(inputs)
            Array.from(annotations).forEach((annotation: any, index) => {
                annotation.addEventListener('pointerover', (event) => {
                    if (index === 1) { // Lazy testing for signature field
                        
                        annotation.style.pointerEvents = 'none';
                        (inputs[3] as HTMLInputElement).blur();  
                        this.signatureInstance = annotation;
                        this.canvas.allowTouchScrolling = false
                        this.canvas.isDrawingMode = true;
                        console.log('Annotation clicked!', annotation);
                    }
                });
            });
        }, 1000); */

        this.canvas.on('path:created', (e) => {
            const path = e.path;
            if (this.checkIfOverlapsAnnotations(path)) {
                console.log(e)
                console.log('Drawing intersects with a PDF annotation!');
            }
        });

        /*  const arrayBuffer = await this.fetchPdfAsArrayBuffer(this.pdfSrc)
         const annotations = await this.loadPdfAndExtractRects(arrayBuffer)
 
         const fabricAnnotations = this.convertAnnotationsToFabric(annotations)
         console.log(fabricAnnotations)
         fabricAnnotations.forEach((obj) => {
             this.canvas.add(obj);
         });
         this.canvas.renderAll(); */

        this.canvas.upperCanvasEl.addEventListener('pointerdown', (e) => {
            /* if (e.pointerType === 'pen' || e.pointerType === 'mouse') {
                // Drawing mode
                this.canvas.isDrawingMode = true;
                this.canvas.allowTouchScrolling = false;
            } else if (e.pointerType === 'touch') {
                // Scroll mode
                this.canvas.isDrawingMode = false;
                this.canvas.allowTouchScrolling = true;
            } */

            // FOR TESTING PURPOSES ONLY
            const isDrawingLikeInput = e.pointerType === 'touch' && e.ctrlKey;
            if (isDrawingLikeInput) {
                this.canvas.isDrawingMode = true;
            } else {
                this.canvas.isDrawingMode = false;
            }
        });

    }

    saveAsPdf(ev: any) {
        const container = document.querySelector('.ng2-pdf-viewer-container') as HTMLCanvasElement;
        const canvasWrapper = document.getElementById('canvasWrapper') as HTMLCanvasElement;
        canvasWrapper.style.width = 'auto';
        const originalHeight = container.offsetHeight;
        const originalOverflow = getComputedStyle(container).overflow;
        container.style.height = container.scrollHeight + 'px';
        container.style.overflow = 'visible';
        html2canvas(container, {
            scale: 2,
            useCORS: true,
        }).then(canvas => {
            container.style.height = originalHeight + 'px';
            container.style.overflow = originalOverflow;
            canvasWrapper.style.width = '100%';
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'pt', 'a4');

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.save('combined.pdf');
        });
    }

    private async fetchPdfAsArrayBuffer(url: string): Promise<ArrayBuffer> {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Failed to fetch PDF: ${response.statusText}`);
        }
        return await response.arrayBuffer();
    }

    async loadPdfAndExtractRects(arrayBuffer: ArrayBuffer): Promise<any[]> {
        const pdfDoc = await PDFDocument.load(arrayBuffer);
        const form = pdfDoc.getForm();
        const annotations: any[] = [];

        form.getFields().forEach(field => {
            const annotation = field.acroField;
            annotations.push({
                name: annotation.getPartialName(),
                type: annotation.constructor.name,
                rect: annotation.getWidgets()[0]?.getRectangle(),
                value: null
            });
        });

        return annotations;
    }

    convertAnnotationsToFabric(annotations: any[]) {
        const fabricObjects = annotations.map(annotation => {
            const { rect, value, type } = annotation;
            console.log(rect, value)
            if (type === 'PDFAcroText') {
                return new Textbox('', {
                    left: rect.x,
                    top: rect.y,
                    fontSize: 14,
                    stroke: 'black',
                    strokeWidth: 2,
                    selectable: true,
                    editable: true,
                    width: rect.width,
                    height: rect.height
                });
            }

            if (type === 'PDFAcroCheckBox') {
                return new Rect({
                    width: rect.width,
                    height: rect.height,
                    left: rect.x,
                    top: rect.y,
                    fill: 'transparent',
                    stroke: 'black',
                    selectable: true,
                    editable: true,
                    strokeWidth: 2,
                    annotation: true
                });
            }
            return null
        }).filter(obj => obj !== null);
        return fabricObjects;
    }

    getAnnotationRects(): DOMRect[] {
        const annotationEls = document.querySelectorAll('.annotationLayer input')

        const rects: DOMRect[] = [];
        annotationEls.forEach(el => {
            const rect = el.getBoundingClientRect();
            const pdfContainerRect = this.canvas.getElement().getBoundingClientRect();

            rects.push({
                top: rect.top - pdfContainerRect.top,
                left: rect.left - pdfContainerRect.left,
                width: rect.width,
                height: rect.height,
                bottom: rect.bottom - pdfContainerRect.top,
                right: rect.right - pdfContainerRect.left,
                x: rect.left - pdfContainerRect.left,
                y: rect.top - pdfContainerRect.top,
                toJSON: () => { } // DOMRect needs this if used elsewhere
            });
        });

        return rects;
    }

    checkIfOverlapsAnnotations(fabricObject: any): boolean {
        const objectRect = fabricObject.getBoundingRect();
        const annotationRects = this.getAnnotationRects();

        return annotationRects.some(ann => {
            return (
                objectRect.left < ann.right &&
                objectRect.left + objectRect.width > ann.left &&
                objectRect.top < ann.bottom &&
                objectRect.top + objectRect.height > ann.top
            );
        });
    }

}